import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Setup / create tour for Add Building page.
 */
export const addBuildingTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_Setup_AddBuilding_Form_Title"),
    description: t("Tour_Setup_AddBuilding_Form_Description"),
    target: () => queryTourTarget("add-building-form"),
    placement: "right",
  },
  {
    title: t("Tour_Setup_AddBuilding_Submit_Title"),
    description: t("Tour_Setup_AddBuilding_Submit_Description"),
    target: () => queryTourTarget("add-building-submit"),
    placement: "top",
  },
];
